angular.module('qkr').factory('keyService', ($http, $q, utils, appConfig) => ({
		keys: null,
		invalidateCache: false,

        listKeys() {
			const self = this;
			if (utils.hasNoValue(self.keys) || self.invalidateCache) {
				return self.reloadKeys();
			} else {
				const deferred = $q.defer();
				deferred.resolve(self.keys);
				return deferred.promise;
			}
		},

        getKey(id) {
            return $http.get(appConfig.apiUrl + 'apiKeyPair/get/' + id, {withCredentials: true}).then((response) => response.data);
        },

        renewKey(currentKey) {
            // Console.log("renewKey");
            const self = this;
            return $http.post(appConfig.apiUrl + 'apiKeyPair/renew', {id: currentKey.id}, {withCredentials: true}).then((response) => {
                if (response.status == 200) {
                self.invalidateCache = true;
                return response.data;
            }
            });
        },

        revokeKey(currentKey) {
            // Console.log("revokeKey");
            const self = this;
            return $http.post(appConfig.apiUrl + 'apiKeyPair/revoke', {id: currentKey.id}, {withCredentials: true}).then((response) => {
                if (response.status == 200) {
                    self.invalidateCache = true;
                    return response.data;
                }
            });
        },

        createKey(currentKey) {
//            Console.log("createKey");
//            Console.log(currentKey);
            // Var self = this;
            return $http.post(appConfig.apiUrl + 'apiKeyPair/create', {label: currentKey.label, passphrase: currentKey.password}, {withCredentials: true}).then((response) => {
                if (response.status == 200) {
                    self.invalidateCache = true;
                    return response.data;
                }
            });
        },
		
		reloadKeys() {
			const self = this;
			return $http.get(appConfig.apiUrl + 'apiKeyPair/list', {withCredentials: true}).then((response) => {
                self.keys = response.data.list;
				return self.keys;
			});
		}
	}));



// WEBPACK FOOTER //
// ./src/services/key.services.js